import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { PriceAmounts } from '@sm360/widget-commons-general';
import { ModelYear, CurrencyFormats } from '@sm360/widget-commons-vehicle';

import 'build-and-quote/components/OptionsPackages/optionsPackage.scss';
import 'build-and-quote/components/DrivePowerTrains/optionsListing.scss';

/* eslint jsx-a11y/no-static-element-interactions: 0 */

const OptionsPackage = ({ optionsPackage, onOptionsPackageClick }) => {
    const purchaseMethodAmount = optionsPackage.configuration.purchaseMethods.getSelectedPurchaseMethodRetailOrPayment();

    const paymentFrequencyLabel = optionsPackage.configuration.purchaseMethods.getPaymentFrequencyLabels(
        false,
        LocaleService
    ).perPeriod;

    const optionsPackageClasses = ['package-type', 'bloc-options__single'];
    if (optionsPackage.selected) {
        optionsPackageClasses.push('selected');
    }

    const openPriceClass = !optionsPackage.selected ? 'option-price is-price' : 'option-price-selected';
    const optionChooseTextColor = !optionsPackage.selected ? 'is-util' : '';
    const optionChooseText = optionsPackage.selected ? 'SELECTED' : 'CHOOSE';

    return (
        <div className={optionsPackageClasses.join(' ')} onClick={onOptionsPackageClick}>
            <div className="bloc-options__single--content">
                <div className="bloc-options__single--body">
                    <p className="bloc-option-title sr-text is-bold">
                        {optionsPackage.configuration.package.description
                            ? optionsPackage.configuration.package.description
                            : LocaleService.t('optionsPackageSection.standard')}
                    </p>
                    <ul className="option-list">
                        <li className="option sr-text is-bold">
                            {LocaleService.t('optionsPackageSection.features')}
                            {optionsPackage.configuration.modelTrim.description}
                        </li>

                        {optionsPackage.configuration.get('featureIcons') &&
                            optionsPackage.configuration.get('featureIcons').map(
                                (feature) =>
                                    !feature.get('isFromModelTrim') && (
                                        <li key={feature.getIn(['iconObject', 'code'])} className="option sr-text">
                                            <span className="option sr-text">+</span>
                                            <div>{feature.getIn(['iconObject', 'typeDescription'])}</div>
                                        </li>
                                    )
                            )}
                    </ul>
                </div>
                <div
                    className={
                        optionsPackage.selected
                            ? 'bloc-options__single--footer selected'
                            : 'bloc-options__single--footer'
                    }
                >
                    <span className="option-from">{LocaleService.t('startingAt')}</span>

                    <span className={openPriceClass}>
                        {purchaseMethodAmount ? (
                            <PriceAmounts price={LocaleService.l(purchaseMethodAmount, CurrencyFormats.CURRENCY_0)} />
                        ) : (
                            ''
                        )}
                        <span className="sub">{paymentFrequencyLabel}</span>
                    </span>
                    <button className="option-choose-cta">
                        <icon className="icon-Crochet" />
                        <span className={optionChooseTextColor}>{LocaleService.t(optionChooseText)}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

OptionsPackage.propTypes = {
    optionsPackage: PropTypes.instanceOf(ModelYear.OptionsPackageModel).isRequired,
    onOptionsPackageClick: PropTypes.func.isRequired,
};

OptionsPackage.displayName = 'OptionsPackage';

export default OptionsPackage;
